<template>
  <div class="py-16 lg:py-24">
    <div class="bg-theme-light rounded-lg py-10 text-center">
      <img src="@/assets/images/emailSent.svg" class="mx-auto">
      <div class="py-6 text-lg font-medium px-5">
        <p class="text-blue text-xl pb-2">Verify your email to proceed!</p>
        <p>
          Thanks for your application. We have just sent an email to the address:
          {{ getUserAuthInfo.email }}
        </p>
        <p>
          Please check your email and click on the link provided to verify your address.
        </p>
        <p>
          If you don’t see it in your inbox, please check spam/junk/promotions folder.
        </p>
      </div>
      <button
        class="bg-theme text-white text-xl font-semibold rounded-full py-2 px-6"
        :disabled="sendingEmail"
        :class="{'opacity-25' : sendingEmail}"
        @click="resendEmail"
      >
        Resend Verification Email
      </button>
      <p class="text-lg font-medium pt-8"> <a :href="contactUrl" style="cursor: pointer;" class="text-blue underline underline-offset-2"> Contact Us</a> | <a @click="signOut" style="cursor: pointer;" class="text-blue underline underline-offset-2">Logout</a></p>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import store from '@/store/index'

export default {
  name: 'EmailVerification',
  beforeRouteEnter: async (to, from, next) => {
    document.title = 'Your application is under review - BuyHive'
    console.log('email verification', store.getters, store.getters.getUserAuthInfo.profileVerified)
    if (!store.getters.isUserLoggedIn || store.getters.getUserAuthInfo.role === 'buyer') {
      console.log('email verification || if')
      window.location.href = `${process.env.VUE_APP_SERVER_BASE_URL}`;
    } else if (store.getters.getIsEmailVerified && store.getters.getUserAuthInfo.profileVerified) {
      console.log('email verification || else if 1')
      next({ name: 'ProfileVerified' })
    }else if(store.getters.getIsEmailVerified && !store.getters.getUserAuthInfo.profileVerified) {
      console.log('email verification || else if 2')
      next({ name: 'AccountReview' })
    }else {
      console.log('email verification || else')
      store.dispatch('checkProfileStatus')
      next()
    }
  },
  watch: {
    getIsEmailVerified(val) {
      if (val) this.$router.push({ name: 'AccountReview' })
    }
  },
  computed: {
    ...mapGetters ([ 'getUserAuthInfo', 'getIsEmailVerified'])
  },
  data() {
    return {
      sendingEmail: false,
      contactUrl: `${process.env.VUE_APP_SERVER_BASE_URL}/buy/contact-us?enquiry_type=Expert Sourcing`
    }
  },
  
  methods: {
    ...mapActions ([
      'resendAccountVerificationEmail',
      'logout'
    ]),
    async resendEmail() {
      this.sendingEmail = true
      setTimeout(() => {
        this.sendingEmail = false
      }, 3000)
      const response = await this.resendAccountVerificationEmail()
      this.$notify({
        group: 'buyHive',
        type: response.result ? 'success' : 'error',
        text: response.message
      })
    },
    async signOut() {
      await this.logout()
      // this.$router.push({ name: 'Home' })
      window.location = process.env.VUE_APP_SERVER_BASE_URL
    },
  }
}
</script>
